import { DiagramDefinition } from "../types";

export const m021Definition: DiagramDefinition = {
  id: "M-021",
  title: "Batch API Transaction Execution Flow",
  description:
    "Transactional execution of batch API operations wrapped in SQLite BEGIN/COMMIT/ROLLBACK transaction blocks. Any failed step triggers an immediate total rollback.",
  viewBox: "0 0 1100 320",
  nodes: [
    { id: "A", kind: "client", label: "POST /api/batch", subtext: "Batch Payload", position: [100, 100], size: [140, 46] },
    { id: "B", kind: "service", label: "Start Transaction", subtext: "BEGIN TRANSACTION", position: [300, 100], size: [150, 46] },
    { id: "C", kind: "service", label: "Operation 1", subtext: "Execute Query 1", position: [500, 100], size: [130, 46] },
    { id: "D", kind: "decision", label: "Success?", subtext: "Step 1 Check", position: [700, 100], size: [110, 46] },
    
    { id: "E", kind: "service", label: "Operation 2", subtext: "Execute Query 2", position: [900, 100], size: [130, 46] },
    
    { id: "F", kind: "status", label: "Rollback All", subtext: "ROLLBACK", position: [700, 240], size: [120, 42], statusColor: "#ef4444" },
    { id: "H", kind: "status", label: "Commit & Return", subtext: "COMMIT 200 OK", position: [900, 240], size: [130, 44], statusColor: "#22c55e" },
  ],
  edges: [
    { id: "e1", source: "A", target: "B", sourcePort: "right", targetPort: "left", routing: "straight", animated: true },
    { id: "e2", source: "B", target: "C", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e3", source: "C", target: "D", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e4", source: "D", target: "E", label: "Yes", sourcePort: "right", targetPort: "left", routing: "straight" },
    { id: "e5", source: "D", target: "F", label: "No", sourcePort: "bottom", targetPort: "top", routing: "straight" },
    { id: "e6", source: "E", target: "H", label: "Yes", sourcePort: "bottom", targetPort: "top", routing: "straight", animated: true },
    { id: "e7", source: "E", target: "F", label: "No", sourcePort: "bottom", targetPort: "top", routing: "orthogonal", midOffset: 140 },
  ],
};
